export default "__VITE_ASSET__0aac0cb4__"